import { View } from 'backbone.marionette';

import formatAsDollars from '@/util/formatAsDollars';

import tmplPRTNRDeviceItemView from './PRTNRDeviceItemView.hbs';

const PRTNRDeviceItemView = View.extend({
  template: tmplPRTNRDeviceItemView,

  className: 'prtnr-device-item-view pt-1 pb-5 px-4',

  ui: {
    price: '.price',
    quantity: '.quantity',
    formattedTotalPrice: '.item-total-cost',
    inputNumberDevices: '.input-number-devices'
  },

  events: {
    'change @ui.quantity': 'onQuantityChange'
  },

  initialize() {
    this.model.set({
      totalPrice: this.model.get('totalPrice') || '0',
      formattedTotalPrice: formatAsDollars(this.model.get('totalPrice') || 0),
      quantity: this.model.get('quantity') || '0'
    });
  },

  onQuantityChange(e) {
    const quantity = this.ui.quantity.val();
    const totalPrice = this.model.get('price') * quantity;
    this.ui.formattedTotalPrice.text(formatAsDollars(totalPrice));
    this.model.set('quantity', quantity);
    this.model.set('totalPrice', totalPrice);
  }
});

export default PRTNRDeviceItemView;
